export default __webpack_public_path__ + "static/media/home-line-chart.c2cbb65b.svg";